import Events from '_utils/events';
import { mapActions } from 'vuex';
import LeadService from '_services/rest/modules/lead';

export default {
  name: 'lead-actions',
  methods: {
    ...mapActions(['setToggle', 'activeAlert']),
    toggleSpam(model) {
      const status = model.status === 'spam' ? 'new' : 'spam';
      LeadService.toggleSpam(model.id, status)
        .then(() => {
          this.$router.push({ name: 'admin-lead-list', params: { page: 1 } });
          Events.$emit('update:pagination', { page: 1 });
        })
        .catch(error => {
          this.activeAlert({
            message: `${error.message} <br/> ${error.data}`,
            theme: 'danger',
          });
        });
    },
  },
};
